import { useQuery } from '@tanstack/react-query';
import { useReferenceOptions } from '../fields/references';
import { KITCHEN_POLL_MS, kitchenKey, useKitchenApi, type KitchenMode } from './model';

/** Stations as filter choices: the store's own list, or at HO every station of every store (the master data). */
export function useStationOptions(mode: KitchenMode): { id: string; label: string }[] {
  const api = useKitchenApi();
  const hoStations = useReferenceOptions(mode === 'ho' ? 'store.station' : undefined);
  const own = useQuery({
    queryKey: [...kitchenKey, 'stations'],
    queryFn: () => api.stations(),
    enabled: mode === 'store',
    refetchInterval: KITCHEN_POLL_MS,
    refetchIntervalInBackground: false,
  });
  if (mode === 'ho') return (hoStations.data ?? []).map((s) => ({ id: s.value, label: s.label }));
  return (own.data ?? []).map((s) => ({ id: s.stationId, label: `${s.code} · ${s.name}` }));
}
